import CampaignSidebarRate from './CampaignSidebarRate'

export default CampaignSidebarRate
